import { IRecommendedServicePackageSchema } from '../../internalTypes';

export function getSelectedRecommendedPackageId(
  recommendedPackages: IRecommendedServicePackageSchema[],
): number | null {
  const firstPackage = recommendedPackages[0];

  return firstPackage?.id || null;
}
